import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-assign-rider',
  templateUrl: './assign-rider.component.html',
  styleUrls: ['./assign-rider.component.scss'],
})
export class AssignRiderComponent {
  assignRiderForm: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AssignRiderComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.assignRiderForm = this.fb.group({
      driverName: ['', Validators.required],
      vehiclePlate: ['', Validators.required],
      primaryCode: ['+233', Validators.required],
      primaryNumber: [
        '',
        [Validators.required, this.phoneValidator('primaryCode')],
      ],
      secondaryCode: ['+233'],
      secondaryNumber: ['', this.phoneValidator('secondaryCode')],
    });
  }

  ngOnInit() {
    // Primary code change listener
    this.assignRiderForm.get('primaryCode')?.valueChanges.subscribe((code) => {
      const control = this.assignRiderForm.get('primaryNumber');
      control?.setValue(''); // Clear the value when country code changes
      control?.updateValueAndValidity();
    });

    // Secondary code change listener
    this.assignRiderForm
      .get('secondaryCode')
      ?.valueChanges.subscribe((code) => {
        const control = this.assignRiderForm.get('secondaryNumber');
        control?.setValue(''); // Clear the value when country code changes
        control?.updateValueAndValidity();
      });
  }

  phoneValidator(codeControlName: string) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) return null;

      const form = control.parent as FormGroup;
      if (!form) return null;

      const countryCode = form.get(codeControlName)?.value;
      const number = control.value.toString();

      // Check if the input contains only digits
      if (!/^\d+$/.test(number)) {
        return { invalidNumber: true };
      }

      return null;
    };
  }

  limitNumberLength(
    codeControlName: string,
    numberControlName: string,
    event: Event
  ) {
    const input = event.target as HTMLInputElement;
    const form = this.assignRiderForm;
    const countryCode = form.get(codeControlName)?.value;
    const maxLength = countryCode === '+233' ? 9 : 10;

    // Remove any non-digit characters
    let value = input.value.replace(/\D/g, '');

    // Trim to max length
    if (value.length > maxLength) {
      value = value.slice(0, maxLength);
    }

    // Update both the input value and form control value
    input.value = value;
    form.get(numberControlName)?.setValue(value);
  }

  onSubmit() {
    if (this.assignRiderForm.valid) {
      this.dialogRef.close(this.assignRiderForm.value);
    }
  }
}
